import { useEffect, useState } from "react";
import { storage } from '@commons';
import { CONFIG_SESSION } from '@handler/common/startSession';
import './style.css';

const TrialLicenseTime = () => {
  const [trialLicense, setTrialLicense] = useState(false);
  const [daysLeft, setDaysLeft] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const configSession = JSON.parse(storage.get(CONFIG_SESSION));
    if (configSession) {
      try {
        const { contaAgrare } = configSession;
        setTrialLicense(contaAgrare.trialLicense || false);
        
        if (contaAgrare.testPeriodEndDate) {
          const endDate = new Date(contaAgrare.testPeriodEndDate);
          const today = new Date();
          const diffTime = endDate - today;
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          setDaysLeft(diffDays > 0 ? diffDays : 0);
        }
      } catch (error) {
        console.error("Erro ao parsear CONFIG_SESSION:", error);
      }
    }
    setLoading(false);
  }, []);

  // Se não for licença trial, não renderiza nada
  if (!trialLicense && !loading) {
    return null;
  }

  const getStatusClass = () => {
    if (daysLeft === null) return "trial-license-loading";
    if (daysLeft <= 3) return "trial-license-alert";
    return "trial-license-normal";
  };

  return (
    <div className={`trial-license-container ${getStatusClass()}`}>
      {!loading && (
        <div className="trial-license-content">
          <span className="trial-license-icon">
            <i className="pi pi-clock"></i>
          </span>
          <span className="trial-license-text">
            {daysLeft !== null ? (
              daysLeft > 0 ? (
                <>Teste ativo: {daysLeft} {daysLeft === 1 ? "dia" : "dias"}</>
              ) : (
                <>Teste expirado</>
              )
            ) : <></>}
          </span>
        </div>
      )}
    </div>
  );
};

export default TrialLicenseTime;
